export const PRODUCT_CATALOGUE_BASE = '/product-catalogue'

export const getProductCataloguePath = () =>
 PRODUCT_CATALOGUE_BASE

export const getProductListPath = () =>
 `${PRODUCT_CATALOGUE_BASE}/product-list`

export const getAddProductPath = () =>
 `${PRODUCT_CATALOGUE_BASE}/add-product`

export const getProductDetailsPath = (
 productId: string | number
) => `${PRODUCT_CATALOGUE_BASE}/product/${productId}`
